import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { toast } from 'sonner';
import api from '../../utils/api';

const ImportBatchDetail = () => {
  const { id } = useParams();
  const [batch, setBatch] = useState(null);
  const [preview, setPreview] = useState([]);

  const loadBatch = async () => {
    try {
      const res = await api.get(`/imports/batches/${id}`);
      setBatch(res.data.batch);
      setPreview(res.data.preview || []);
    } catch (error) {
      toast.error('Error al cargar batch');
    }
  };

  useEffect(() => {
    loadBatch();
  }, [id]);

  const handleAction = async (action) => {
    try {
      await api.post(`/imports/batches/${id}/${action}`);
      toast.success('Accion ejecutada');
      loadBatch();
    } catch (error) {
      toast.error('Error al ejecutar accion');
    }
  };

  if (!batch) {
    return <div className="text-muted-foreground">Cargando...</div>;
  }

  return (
    <div className="max-w-6xl mx-auto space-y-6" data-testid="client-import-batch">
      <div>
        <h1 className="text-3xl font-heading font-bold">Batch {batch.id}</h1>
        <p className="text-muted-foreground">
          {batch.type} · {batch.period || 'N/A'} · {batch.status}
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Acciones</CardTitle>
        </CardHeader>
        <CardContent className="flex flex-wrap gap-2">
          <Button onClick={() => handleAction('validate')}>Validar</Button>
          <Button variant="outline" onClick={() => handleAction('process')}>Procesar</Button>
          <Button variant="outline" onClick={() => handleAction('export-holded')}>Exportar a Holded</Button>
          <Button variant="ghost" onClick={() => window.location.assign(`${process.env.REACT_APP_BACKEND_URL}/api/imports/batches/${batch.id}/errors.csv`)}>
            Descargar errores
          </Button>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Resumen</CardTitle>
        </CardHeader>
        <CardContent className="grid grid-cols-3 gap-4 text-sm">
          <div>Total: {batch.totals?.rows_total || 0}</div>
          <div>Validas: {batch.totals?.rows_valid || 0}</div>
          <div>Invalidas: {batch.totals?.rows_invalid || 0}</div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>Preview</CardTitle>
        </CardHeader>
        <CardContent className="overflow-x-auto">
          {preview.length === 0 ? (
            <div className="text-sm text-muted-foreground">Sin datos.</div>
          ) : (
            <table className="min-w-full text-sm">
              <thead>
                <tr>
                  <th className="text-left p-2">#</th>
                  <th className="text-left p-2">Estado</th>
                  <th className="text-left p-2">Datos</th>
                  <th className="text-left p-2">Errores</th>
                </tr>
              </thead>
              <tbody>
                {preview.map((row) => (
                  <tr key={row.id} className="border-t">
                    <td className="p-2">{row.row_number}</td>
                    <td className="p-2">{row.status}</td>
                    <td className="p-2">
                      <pre className="text-xs whitespace-pre-wrap">{JSON.stringify(row.raw_json, null, 2)}</pre>
                    </td>
                    <td className="p-2">
                      {row.errors?.length ? (
                        <ul className="text-xs text-red-600">
                          {row.errors.map((err, idx) => (
                            <li key={idx}>{err.column}: {err.message}</li>
                          ))}
                        </ul>
                      ) : (
                        <span className="text-xs text-muted-foreground">OK</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default ImportBatchDetail;
